import apiFetch from "../../../shared/services/apiClient";

export async function createOrGetPersona({ cedula, nombre, apellidos, nombre_sociedad }) {
  const body = {
    cedula,
    nombre:          nombre          || '',
    apellidos:       apellidos       || '',
    nombre_sociedad: nombre_sociedad || '',
  };
  const res = await apiFetch("/api/residents/persona/", {
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(JSON.stringify(err));
  }
  const data = await res.json();
  return data.id;
}
